import { apiTokensService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import {
  SET_API_TOKENS,
  DELETE_API_TOKEN,
  CREATED_API_TOKEN,
  CLEAN_CREATED_API_TOKEN
} from './mutationTypes';
import {
  GET_API_TOKEN_LIST,
  DELETE_API_TOKEN_ACTION,
  CREATE_API_TOKEN_ACTION
} from './actionTypes';
import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR
} from '@/store/helpers';

const actions = {
  async getApiTokensList({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_API_TOKEN_LIST });
    await apiTokensService.getApiTokens()
      .then((response) => {
        commit(SET_API_TOKENS, response.data.apiTokens);
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_API_TOKEN_LIST });
      }).catch((e) => {
        commit(SET_ACTION_STATUS_ERROR, { actionName: GET_API_TOKEN_LIST, error: e });
      });
  },

  async deleteApiToken({ commit }, apiTokenModel) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_API_TOKEN_ACTION });
    return await apiTokensService.deleteApiToken(apiTokenModel)
      .then(() => {
        commit(DELETE_API_TOKEN, apiTokenModel);
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_API_TOKEN_ACTION });
      }).catch((e) => {
        commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_API_TOKEN_ACTION, error: e });
        throw e;
      });
  },

  async createApiToken({ commit }, model) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: CREATE_API_TOKEN_ACTION });
    return await apiTokensService.createApiToken(model)
      .then((response) => {
        commit(CREATED_API_TOKEN, response);
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: CREATE_API_TOKEN_ACTION });
      }).catch((e) => {
        commit(SET_ACTION_STATUS_ERROR, { actionName: CREATE_API_TOKEN_ACTION, error: e });
        throw e;
      });
  },

  async cleanCreatedApiToken({ commit }) {
    commit(CLEAN_CREATED_API_TOKEN);
  }
};

export default actions;
